export default __webpack_public_path__ + "39ec4f0503976ea49ded9da3f4c3dcce.png";